<label class="switch">
  <input disabled type="checkbox" [checked]="active" />
  <span class="slider round"></span>
</label>
